import { render, staticRenderFns } from "./user_information.vue?vue&type=template&id=4400914b&scoped=true&"
import script from "./user_information.vue?vue&type=script&lang=js&"
export * from "./user_information.vue?vue&type=script&lang=js&"
import style0 from "./user_information.vue?vue&type=style&index=0&id=4400914b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4400914b",
  null
  
)

export default component.exports